// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import React from 'react';

import { LoadableBackground } from '@confluence/loadable';

const NthUserOrientationLoadable = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NthUserOrientation" */ './NthUserOrientationInner.tsx'
			)
		).NthUserOrientation,
});

export const NthUserOrientation = () => {
	return <NthUserOrientationLoadable />;
};
